<template>
  <b-container>
    <div id="control-header" style="padding: 10px; font-size: large; font-weight: bold">Fertilizer Data</div>
    <b-button size="sm" @click="requestDownload()" v-if="admin">
      Export Fertilizer Data
    </b-button>
    <ag-grid-vue style="width: 100%; height: 500px;"
                 class="ag-theme-balham"
                 :columnDefs="this.fertilizerColumnDefs"
                 :rowData="this.fertilizerRowData">
    </ag-grid-vue>
  </b-container>
</template>

<script>
import {AgGridVue} from "ag-grid-vue";
import {FileUtils} from "@/lib/FileUtils";
import {
  isAdmin,
  isAdminClass,
  isAdminOrCertifier,
  isAdminVineyardAdminOrCertifier,
  isCertifier,
  isNonCertifierAdmin,
  isPureAdmin,
  isVineyardAdmin,
  isVineyardAdminMeth
} from "@/lib/UserUtils";

export default {
  name: "VineyardSimpleFertilizerMetricTable",
  props: {groupId: String},
  components: {
    AgGridVue
  },

  data() {
    return {
      fertilizerColumnDefs: null,
      fertilizerRowData: [],
      rowStyle1: {fontWeight: 'bold'},
      theGroupId: this.groupId,
      admin: isAdmin()
    }
  },
  beforeMount() {
    this.fertilizerColumnDefs = [
      {
        headerName: 'Month',
        field: 'meterUsage',
        pinned: "left",
        lockPinned: true,
        width: 100,
        editable: false
      },
      {
        headerName: 'Solid (Lbs)',
        field: 'solid',
        valueParser: this.numberParser,
        editable: false
      },
      {
        headerName: 'Liquid (Lbs)',
        field: 'liquid',
        valueParser: this.numberParser,
        editable: false
      },
      {
        headerName: 'Compost (Tons)',
        field: 'compost',
        valueParser: this.numberParser,
        editable: false
      },
      {
        headerName: 'Manure (Tons)',
        field: 'manure',
        valueParser: this.numberParser,
        editable: false
      }
    ];

    let theGroup = this.theGroupId;
    let self = this;
    this.$http.get("metrics/vineyard/fertilizer/graph/" + theGroup)
        .then(resultWater => {

          self.fertilizerRowData = resultWater.data;
        }).catch(
        error => {
          console.log(error)
        });
  },
  methods: {
    requestDownload() {
      let self = this;
      this.$http.get(`metrics/download/${self.myGroupId}/fertilizer/vineyard`, {responseType: "blob"})
          .then(async response => {
            FileUtils.saveExcelToDisk(response);
          });
    },
  }
}
</script>

<style scoped>

</style>
